import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Button from '../Button';
import styles from './FabItem.less';

class FabItem extends React.PureComponent {
  render() {
    const { className, children, icon, ...rest } = this.props;
    const classNames = cn(styles.button, className);

    return (
      <Button className={classNames} {...rest}>
        {icon && <div className={styles.iconWrapper}>{icon}</div>}
        {children}
      </Button>
    );
  }
}

FabItem.propTypes = {
  ...Button.propTypes,
  icon: PropTypes.node,
  children: PropTypes.node.isRequired,
};

FabItem.defaultProps = {
  size: 'small',
  color: 'scouting-warm-gray',
  fitText: true,
  ghost: true,
  noBorder: true,
  uppercase: false,
};

export default FabItem;
